import { useQueries } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getLedgerWallets } from 'services/LedgerService'

export const useGetLedgerWalletsByCurrencies = (currencies: string[]) => {
  return useQueries({
    queries: currencies.map(currency => ({
      queryKey: reactQueryKeys.ledgerWallets(currency),
      queryFn: () => getLedgerWallets({ currencyCode: currency }),
      enabled: currencies.length > 0,
    })),
  })
}
